import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'section[app-home-products-banner]',
  imports: [RouterModule],
  templateUrl: './home-products-banner.html',
  styleUrl: './home-products-banner.scss',
})
export class HomeProductsBanner {}
